export const sum = (arr) => {
  if (arr.length === 0) {
    return 0;
  }
  return arr.reduce((pre, cur) => {
    return (pre + cur);
  });
};
